export default {"src":"/_next/static/media/pinch.f2a5962d.svg","height":64,"width":65,"blurWidth":0,"blurHeight":0};